import {
  Container,
  Heading,
  Image,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import DCLogo from "../../../resources/images/dc_comics.svg";
import ImageLogo from "../../../resources/images/image.svg";
import MarvelLogo from "../../../resources/images/marvel.svg";
import StarWarsLogo from "../../../resources/images/star_wars.svg";
import ReadingList from "../components/ReadingList";
import {
  getReadingTabIndexFromFranchise,
  getStoredReadingTabIndex,
  persistReadingTabIndex,
} from "../readingTabStorage";

const CompletedReadingOrders = () => {
  const location = useLocation();
  const franchise = new URLSearchParams(location.search).get("franchise");
  const routeTabIndex = getReadingTabIndexFromFranchise(franchise);
  const [tabIndex, setTabIndex] = useState(getStoredReadingTabIndex);

  useEffect(() => {
    if (routeTabIndex !== null) {
      setTabIndex(routeTabIndex);
      persistReadingTabIndex(routeTabIndex);
    }
  }, [routeTabIndex]);

  const onTabChange = (index) => {
    setTabIndex(index);
    persistReadingTabIndex(index);
  };

  return (
    <Container>
      <Heading as="h2" my="6">
        Completed reading orders
      </Heading>

      <Tabs index={tabIndex} onChange={onTabChange} isLazy>
        <TabList>
          <Tab>
            <Image src={MarvelLogo} height={30} />
          </Tab>
          <Tab>
            <Image src={DCLogo} height={30} />
          </Tab>
          <Tab>
            <Image src={StarWarsLogo} height={45} />
          </Tab>
          <Tab>
            <Image src={ImageLogo} height={29} />
          </Tab>
        </TabList>
        <TabPanels>
          <TabPanel>
            <ReadingList franchise={1} completed={1} />
          </TabPanel>
          <TabPanel>
            <ReadingList franchise={2} completed={1} />
          </TabPanel>
          <TabPanel>
            <ReadingList franchise={3} completed={1} />
          </TabPanel>
          <TabPanel>
            <ReadingList franchise={4} completed={1} />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Container>
  );
};

export default CompletedReadingOrders;
